import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class MessageEmail extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/message/email'
        super(store, path)
    }

    send(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/send`,
            method: 'PATCH',
            showProgress
        })
    }

    sendDemo(id, showProgress) {
        return this._request({
            action: `${this._urlencode(id)}/demo`,
            method: 'PATCH',
            showProgress
        })
    }
}